import React from 'react';
import { Formik, Form } from 'formik';
import Modal from '../../audi-ui-components/Modal';
import IconSystemHelp from '../../audi-ui-components/icons/SystemHelp';
import Spinner from '../../audi-ui-components/Spinner';
import Button from '../../audi-ui-components/Button';
import FormField from './FormField';
import VINHelp from '../../components/VINHelp';
import { request } from '../../functions/apiRequestHelper';
import { validate } from '../../functions/validation';
import { formatNumber } from '../../functions/textFormatting';
import { gtmPush } from '../../functions/gtm';
import  { FIELD_SELECT, STATES_OPTIONS } from '../../constants';

const REGO_LOOKUP = true;

class VehicleSearchForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showVinHelp: false,
            serverError: null,
            isNotEligible: false,
            isNotEligibleComment: null,
            vinNotFound: false,
            regoNotFound: false
        }
    }

    validateForm = (values) => {
        if (!values.vin && !values.rego) {
            return {
                vin: "Please enter your registration number or VIN",
                rego: "Please enter your registration number or VIN"
            };
        }
        let schema = {};
        if (values.vin) {
            schema = {
                vin: {
                    isVin: { message: "Please enter a valid VIN" }
                },
                vinMileage: {
                    presence: { message: "This field is required", allowEmpty: false }
                }
            }
        } else {
            schema = {
                rego: {
                    presence: { message: "Please enter your registration number", allowEmpty: false }
                },
                regoState: {
                    presence: { message: "Please select a state", allowEmpty: false }
                },
                regoMileage: {
                    presence: { message: "This field is required", allowEmpty: false }
                }
            }
        }
        return validate(values, schema, {format: "firstError", fullMessages: false});
    }

    submitForm = (values, formikBag) => {
        this.setState({serverError: null, regoNotFound: false});
        if (values.vin) {
            this.lookupVin({vin: values.vin, mileage: values.vinMileage}, formikBag, "BspSearchForPlan");
        } else {
            request(
                `${process.env.RAZZLE_API_HOST}/2/services/vehicle/${values.rego}/${values.regoState}`,
                {
                    method: 'POST',
                }
            ).then(response => {
                // console.log(response);
                if (response.vin) {
                    this.lookupVin(
                        {vin: response.vin, mileage: values.regoMileage, regoPlate: values.rego, regoState: values.regoState},
                        formikBag,
                        "BspSearchForPlanRego"
                    );
                } else {
                    this.setState({regoNotFound: true});
                }
            }).catch(error => {
                // console.error(error);
                if (error.status === 404) {
                    this.setState({regoNotFound: true});
                } else {
                    let msg = "An error has occured";
                    if (error.message) {
                        msg = error.message;
                    } else if (error.body && error.body.message) {
                        msg = error.body.message;
                    }
                    this.setState({serverError: msg});
                }
                formikBag.setSubmitting(false);
            });
        }
    }

    lookupVin = (vehicle, formikBag, gtmAction) => {
        // request body:
        // {vehicle: {vin: "", mileage: ""}}
        request(
            `${process.env.RAZZLE_API_HOST}/1/serviceplan/validateVIN`,
            {
                method: 'POST',
                body: JSON.stringify({vehicle: vehicle}),
            }
        ).then(response => {
            // success
            gtmPush("buyServicePlan", gtmAction, "BspStart");
            response.vehicleEligibleForRetailPlan = response.vehicleEligibleForRetailPlan === "true";
            response.vehicleEligibleForTopupPlan = response.vehicleEligibleForTopupPlan === "true";
            /*
            // for testing when no vaid VINs available
            response.vehicleEligibleForRetailPlan = true;
            response.vehicleEligibleForTopupPlan = true;
            response.plans = {
                plan1: {
                    code: "FDSP3YEAR",
                    name: "3 Year Service Plan",
                    duration: "3 Years / 45,000 KM's",
                    maxMileage: "45,000 KM's",
                    price: "$1,995.00",
                    serviceDetails: [
                        { interval: "15,000 km / 12 months", inclusions: "Engine oil and filter change<br>Inspection of brake system, tyres, exhaust<br>Multi-point vehicle inspection" },
                        { interval: "30,000 km / 24 months", inclusions: "Engine oil and filter change<br>Air filter replacement<br>Cabin filter replacement<br>Brake fluid replacement<br>Multi-point vehicle inspection" },
                        { interval: "45,000 km / 36 months", inclusions: "Engine oil and filter change<br>Inspection of brake system, tyres, exhaust<br>Multi-point vehicle inspection" }
                    ],
                    disclaimer: "<p>*Terms and conditions apply. Service plan covers scheduled servicing only. Exclusions apply.</p>",
                    termsLink: "https://www.audi.com.au/au/web/en/service-plan-terms.html"
                },
                plan2: {
                    code: "FDSP5YEAR",
                    name: "5 Year Service Plan",
                    duration: "5 Years / 75,000 KM's",
                    maxMileage: "75,000 KM's",
                    price: "$2,995.00",
                    serviceDetails: [
                        { interval: "15,000 km / 12 months", inclusions: "Engine oil and filter change<br>Inspection of brake system, tyres, exhaust<br>Multi-point vehicle inspection" },
                        { interval: "30,000 km / 24 months", inclusions: "Engine oil and filter change<br>Air filter replacement<br>Cabin filter replacement<br>Brake fluid replacement<br>Multi-point vehicle inspection" },
                        { interval: "45,000 km / 36 months", inclusions: "Engine oil and filter change<br>Inspection of brake system, tyres, exhaust<br>Multi-point vehicle inspection" },
                        { interval: "60,000 km / 48 months", inclusions: "Engine oil and filter change<br>Air filter replacement<br>Cabin filter replacement<br>Spark plug replacement<br>Multi-point vehicle inspection" },
                        { interval: "75,000 km / 60 months", inclusions: "Engine oil and filter change<br>Inspection of brake system, tyres, exhaust<br>Multi-point vehicle inspection" }
                    ],
                    disclaimer: "<p>*Terms and conditions apply. Service plan covers scheduled servicing only. Exclusions apply.</p>",
                    termsLink: "https://www.audi.com.au/au/web/en/service-plan-terms.html"
                }
            };*/
            if (response.vehicleEligibleForRetailPlan || response.vehicleEligibleForTopupPlan) {
                this.props.setSearchResult(response, vehicle);
            } else {
                this.setState({isNotEligible: true, isNotEligibleComment: response.vehicleEligibleForTopupPlanComments});
            }
        }).catch(error => {
            // error
            // console.error(error);
            if (error.status === 404) {
                this.setState({vinNotFound: true});
            } else {
                let msg = "An error has occured";
                if (error.message) {
                    msg = error.message;
                } else if (error.body && error.body.message) {
                    msg = error.body.message;
                }
                this.setState({serverError: msg});
            }
            formikBag.setSubmitting(false);
        });
    }

    render() {
        if (this.state.isNotEligible) {
            return (
                <div className="row mb-5">
                    <div className="col-small-1"></div>
                    <div className="col-small-5 col-large-6">
                        <p className="aui-headline-4 mb-3">Your vehicle is not eligible for a service plan.</p>
                        <p className="mb-5">{this.state.isNotEligibleComment}</p>
                        <Button label="Book a service" buttonType="primary" theme={this.props.theme === "dark" ? "light" : null} onClick={this.props.onClickBookService} />
                    </div>
                    <div className="col-small-1"></div>
                    <div className="col-small-4 col-large-3">
                        {this.props.contact}
                    </div>
                </div>
            );
        }
        if (this.state.vinNotFound) {
            return (
                <div className="row mb-5">
                    <div className="col-small-1"></div>
                    <div className="col-small-5 col-large-6">
                        <p className="aui-headline-4 mb-3">Sorry, we couldn't find your vehicle details.</p>
                        <p className="mb-5">Please contact your preferred dealer to enquire about purchasing a service plan.</p>
                        <Button label="Locate a dealer" buttonType="primary" theme={this.props.theme === "dark" ? "light" : null} onClick={this.props.onClickLocateDealer} />
                    </div>
                    <div className="col-small-1"></div>
                    <div className="col-small-4 col-large-3">
                        {this.props.contact}
                    </div>
                </div>
            );
        }
        return (
            <div className="mb-5">
                <p className="aui-headline-4 mb-3">
                    Reassuringly comprehensive and offering great value, the Audi Service Plan guarantees that
                    your Audi receives all of its scheduled servicing needs, giving you complete peace of mind.
                </p>
                <p className="aui-headline-4">Enter your details below to choose a suitable plan.</p>
                <hr className="my-5" />
                <Formik initialValues={this.props.vin ? {vin: this.props.vin} : {}} validate={this.validateForm} onSubmit={this.submitForm}>
                    {formikBag => (
                        <Form className="position-relative">
                            {formikBag.isSubmitting && <div className="spinner-wrapper"><Spinner isContinuous /></div>}
                            <div className="row">
                                {REGO_LOOKUP && <div className="col-12 col-medium-5">
                                    <p className="aui-headline-4 mb-3">Enter your registration details</p>
                                    <FormField name="rego" label="Registration number" formikBag={formikBag} theme={this.props.theme} />
                                    <FormField name="regoState" label="Registration state" fieldType={FIELD_SELECT} options={STATES_OPTIONS} formikBag={formikBag} theme={this.props.theme} />
                                    <FormField name="regoMileage" label="Number of KM's" formatValue={formatNumber} formikBag={formikBag} theme={this.props.theme} />
                                    {this.state.regoNotFound && <p className="py-3 aui-color-text-red">We can't find a matching Audi VIN with the registration number you have entered. Please try entering the VIN directly.</p>}
                                </div>}
                                {REGO_LOOKUP && <div className="col-12 col-medium-2">
                                    <div className="or aui-headline-5"><span>OR</span></div>
                                </div>}
                                <div className="col-12 col-medium-5">
                                    <p className="aui-headline-4 mb-3">Enter your Vehicle Identification Number (VIN)</p>
                                    <FormField name="vin" label="VIN" formikBag={formikBag} theme={this.props.theme} />
                                    <p><IconSystemHelp small /> Not sure how to find your VIN? <span className="aui-textlink" onClick={() => { this.setState({showVinHelp: true}); gtmPush("buyServicePlan", "BspFindYourVin", "BspStart"); }}>Find out how.</span></p>
                                    <FormField name="vinMileage" label="Number of KM's" formatValue={formatNumber} formikBag={formikBag} theme={this.props.theme} />
                                </div>
                            </div>
                            {this.state.serverError && <p className="my-5 aui-color-text-red">{this.state.serverError}</p>}
                            <p className="mt-5">
                                <Button label="Search for a plan" buttonType="primary" theme={this.props.theme === "dark" ? "light" : null} type="submit" />
                            </p>
                        </Form>
                    )}
                </Formik>

                <Modal isActive={this.state.showVinHelp} modalStyle="layer" closeButton close={() => { this.setState({showVinHelp: false}); }}>
                    <VINHelp />
                </Modal>
            </div>
        );
    }
}

export default VehicleSearchForm;
